import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    $('.js-staff-updated').change(function() {
      return $(this).submit();
    });
  }
}
